export default __webpack_public_path__ + "static/media/WorkSans-Regular.bb287b89.ttf";